import { useQuery } from "@tanstack/react-query";
import { getPickupFieldsMetadata } from "../api/licenseApplicationApi";
import { licenseApplicationKeys } from "../api/licenseApplicationKeys";

export const usePickupFieldsMetadata = () =>
  useQuery({
    queryKey: licenseApplicationKeys.fieldsMetadata(),
    queryFn: getPickupFieldsMetadata,
  });
